import BaseApi from './baseApi';
import IListDock from '../models/IListDock';
import IAuthentication from '../models/IAuthentication';
export default class ListCustomPapersApi extends BaseApi {
    idUser : string = "";
    idCompany : string = "";
    constructor() {
        super("dataaccess", "Inbounds");
        let userFromStorage : IAuthentication = JSON.parse(sessionStorage.getItem('user') || '{}');
        this.idUser = userFromStorage.idPerson;
        this.idCompany = userFromStorage.idCompany;
    }

    async GetListDocks(idCompany: string) : Promise<IListDock[]> {
        const json = this.getJsonRead(idCompany);
        const response = await this.api.post('read', json);
        if (!response) return [];
        if (response.isSuccess) {
            var listDocks: IListDock[] = [];
            listDocks = response.data as IListDock[];
            return listDocks;
        } else {
            this.modelState = response.errorState;
            return [];
        }
    }

    async SaveListDock(dock: IListDock) : Promise<string> {
        const json = this.getJsonSave(dock);
        const response = await this.api.post('save', json);
        if (!response) return "";
        if (response.isSuccess) {
            return response.data as string;
        } else {
            this.modelState = response.errorState;
        }

        return "";
    }

    async UpdateListDock(dock: IListDock) : Promise<boolean> {
        const json = this.getJsonUpdate(dock);
        const response = await this.api.post('save', json);
        return this.isSuccess(response);
    }

    async DeleteListDock(id: string) : Promise<boolean> {
        const json = this.getJsonDelete(id);
        const response = await this.api.post('delete', json);
        return this.isSuccess(response);
    }

    async inUseSetting(id: string) : Promise<boolean> {
        const json = this.getInUseJson(id);
        const response = await this.api.post('ExecWithResults', json);
        if (!response) return false;
        if (response.isSuccess) {
            const data = response.data as any[];
            return Number(data && data[0] && data[0].isInUse) === 1;
        } else {
            this.modelState = response.errorState;
            return false;
        }
    }

    private getInUseJson(id: string) : any {
        const json = {
            "spname": "dbo.IS_DOCK_IN_USE",
            "parameters": [{
                "Item1": "DockId ",
                "Item2": id
            }, {
                "Item1": "companyId ",
                "Item2": this.idCompany
            }]
        };
        return json;
    }

    private getJsonRead(idCompany: string) : any {
        const json = {
            "fields": [{
                "Item1": "ListDocks",
                "Item2": "id"
            }, {
                "Item1": "ListDocks",
                "Item2": "name"
            }, {
                "Item1": "ListDocks",
                "Item2": "idCompany"
            }, {
                "Item1": "ListDocks",
                "Item2": "idWarehouse"
            }, {
                "Item1": "Warehouses",
                "Item2": "name"
            }],
            "tables": [{
                "Item1": "ListDocks"
            }, {
                "Item1": "Warehouses"
            }],
            "joins": [{
                "Item1": "ListDocks",
                "Item2": "IdWarehouse",
                "Item3": "Warehouses",
                "Item4": "Id"
            }],
            "conditions": [{
                "Item1": "ListDocks",
                "Item2": "Deleted",
                "Item3": "=",
                "Item4": "0",
                "Item5": "AND"
            }, {
                "Item1": "ListDocks",
                "Item2": "idCompany",
                "Item3": "=",
                "Item4": idCompany
            }],
            "orderBy": [{
                "Item1": "ListDocks.name"
            }]
        };
        return json;
    }

    private getJsonDelete(id: string) : any {
        const json = {
            "deleteMetadata": [{
                "Item1": "DeletedBy",
                "Item2": this.idUser
            }, {
                "Item1": "DeletedDate",
                "Item2": new Date()
            }],
            "table": "ListDocks",
            "conditions": [{
                "Item1": "ListDocks",
                "Item2": "id",
                "Item3": "=",
                "Item4": id
            }]
        };
        return json;
    }

    private getJsonSave(dock: IListDock) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": dock.name
            }, {
                "Item1": "idCompany",
                "Item2": dock.idCompany
            }, {
                "Item1": "idWarehouse",
                "Item2": dock.idWarehouse
            }, {
                "Item1": "Deleted",
                "Item2": 0
            }, {
                "Item1": "CreatedBy",
                "Item2": this.idUser
            }, {
                "Item1": "CreatedDate",
                "Item2": new Date()
            }],
            "table": "ListDocks"
        };
        return json;
    }

    private getJsonUpdate(dock: IListDock) : any {
        const json = {
            "fieldsvalues": [{
                "Item1": "name",
                "Item2": dock.name
            }, {
                "Item1": "ModifiedBy",
                "Item2": this.idUser
            }, {
                "Item1": "ModifiedDate",
                "Item2": new Date()
            }],
            "table": "ListDocks",
            "keyvalue": dock.id
        };
        return json;
    }
}
